import { render, staticRenderFns } from "./NewAiRobotRenew.vue?vue&type=template&id=7c4c3df6&"
import script from "./NewAiRobotRenew.vue?vue&type=script&lang=js&"
export * from "./NewAiRobotRenew.vue?vue&type=script&lang=js&"
import style0 from "./NewAiRobotRenew.vue?vue&type=style&index=0&id=7c4c3df6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports